<p-toast></p-toast>
<div class="system-documentation-block-form-content">
  <div class="system-documentation-block-layout-content">
    <div class="flex flex-row h-full flex-responsive gap-3 flex-wrap">

      <!-- Form Fields -->
      <div class="lg:col-12 md:col-12 sm:col-12">
        <div class="form-section">
          <div class="section-title">
            <h3>{{ 'Block Information' | translate }}</h3>
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Name (UZ)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['uz-Latn-UZ']"
              (change)="onNameChange()"
              placeholder="{{ 'Name' | translate }}" />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one name is required' | translate }}</span>
            }
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Name (EN)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['en-US']"
              (change)="onNameChange()"
              placeholder="{{ 'Name' | translate }}" />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one name is required' | translate }}</span>
            }
          </div>

          <div class="field-group" [class.has-error]="fieldErrors.names">
            <label>
              {{ 'Name (RU)' | translate }}
              <span class="required-star">*</span>
            </label>
            <msf-input
              [(model)]="formData.names['ru-RU']"
              (change)="onNameChange()"
              placeholder="{{ 'Name' | translate }}" />
            @if (fieldErrors.names && !isFormValid()) {
              <span class="error-message">{{ 'At least one name is required' | translate }}</span>
            }
          </div>

          <div class="field-group">
            <label>{{ 'Parent Block' | translate }}</label>
            <msf-select-paginated
              [(model)]="formData.parentId"
              [service]="systemDocumentationBlockService"
              serviceMethod="dictionariesSystemDocumentationBlockGetByQueryPost"
              [placeholder]="'Select parent block' | translate"
              optionLabel="name"
              optionValue="id"
              translateBy="names"
              searchBy="names"
              [filter]="parentBlockFilter" />
          </div>

          <div class="field-group">
            <label>{{ 'Order Code' | translate }}</label>
            <msf-input
              [(model)]="formData.orderCode"
              type="number"
              placeholder="{{ 'Order Code' | translate }}" />
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Form Actions - Bottom Right -->
  <div class="form-actions-footer">
    <app-secondary-button
      [title]="'Cancel' | translate"
      (action)="cancelForm()">
    </app-secondary-button>

    <div style="padding: 0;">
      <app-primary-button
        [loading]="isSaving()"
        (action)="saveSystemDocumentationBlock()"
        title="Save">
      </app-primary-button>
    </div>
  </div>
</div>

